// Ported from LC2 (src/commons/utils/messagingUtils.js) — only the summary-stat
// calculators the new Communications tab needs (CommunicationsPanel.js); LC2's
// NotifyIssueBySlack helper here is unrelated UI, not ported.
export const findEmailSummaryStats = (data) => {
    let totalOpened = 0;
    let totalClicked = 0;

    data.forEach((ele) => {
        if (ele.opened) totalOpened++;
        if (ele.clicked) totalClicked++;
    });

    return {
        openRate: Math.round((totalOpened / data.length) * 100),
        clickRate: Math.round((totalClicked / data.length) * 100)
    };
};

export const findTextSummaryStats = (data) => {
    let totalDelivered = 0;

    data.forEach((ele) => {
        if (ele.delivered) totalDelivered++;
    });

    return {deliveryRate: Math.round((totalDelivered / data.length) * 100)};
};

export const findPushSummaryStats = (data) => {
    let totalClicked = 0;
    let totalDelivered = 0;

    data.forEach((ele) => {
        if (ele.delivered) totalDelivered++;
        if (ele.clicked) totalClicked++;
    });

    return {
        deliveryRate: Math.round((totalDelivered / data.length) * 100),
        clickRate: Math.round((totalClicked / data.length) * 100)
    };
};
